import SearchResultList from "components/common/SearchResultList";
import UnitCat from "../UnitCat/UnitCat";
import { DlUnit } from "model/dl_unit/DlUnit";
import styled from "styled-components";
import UnitCatEdit from "components/admin/pages/dl_unit/UnitCatEdit";
import { useCallback } from "react";

type UnitListProps = {
  units: DlUnit[];
  editMode?: boolean;
};

const UnitList = ({ units, editMode }: UnitListProps) => {
  const renderSingle = useCallback(
    (item: DlUnit, ind: number) =>
      !editMode ? (
        <UnitCat item={item} catInd={ind + 1} key={`unit_${ind + 1}`} />
      ) : (
        <UnitCatEdit unit={item} key={`unit_${ind + 1}`} />
      ),
    [editMode], // Dependency: only recreate when editMode changes
  );

  return (
    <Div>
      <SearchResultList<DlUnit> renderSingle={renderSingle} results={units} />
    </Div>
  );
};

const Div = styled.div`
  margin-bottom: 1rem;
`;

export default UnitList;
